export const queryKeys = {
  DASHBOARD_VIEW: 'dashboard-view',
  CHART_VIEW: 'chart-view'
}